{
  "main": {
    "en": {
      "identity": {
        "language": "en"
      },
      "listPatterns": {
        "listPattern-type-standard": {
          "start": "{0}, {1}",
          "middle": "{0}, {1}",
          "end": "{0}, and {1}",
          "2": "{0} and {1}"
        },
        "listPattern-type-or": {
          "start": "{0}, {1}",
          "middle": "{0}, {1}",
          "end": "{0}, or {1}",
          "2": "{0} or {1}"
        },
        "listPattern-type-or-narrow": {
          "start": "{0}, {1}",
          "middle": "{0}, {1}",
          "end": "{0}, or {1}",
          "2": "{0} or {1}"
        },
        "listPattern-type-or-short": {
          "start": "{0}, {1}",
          "middle": "{0}, {1}",
          "end": "{0}, or {1}",
          "2": "{0} or {1}"
        },
        "listPattern-type-standard-narrow": {
          "start": "{0}, {1}",
          "middle": "{0}, {1}",
          "end": "{0}, {1}",
          "2": "{0}, {1}"
        },
        "listPattern-type-standard-short": {
          "start": "{0}, {1}",
          "middle": "{0}, {1}",
          "end": "{0}, & {1}",
          "2": "{0} & {1}"
        },
        "listPattern-type-unit": {
          "start": "{0}, {1}",
          "middle": "{0}, {1}",
          "end": "{0}, {1}",
          "2": "{0}, {1}"
        },
        "listPattern-type-unit-narrow": {
          "start": "{0} {1}",
          "middle": "{0} {1}",
          "end": "{0} {1}",
          "2": "{0} {1}"
        },
        "listPattern-type-unit-short": {
          "start": "{0}, {1}",
          "middle": "{0}, {1}",
          "end": "{0}, {1}",
          "2": "{0}, {1}"
        }
      }
    }
  }
}
